import { AxiosBasicCredentials, AxiosError } from "axios";
import { useMutation } from "react-query";
import HttpService from "../services/http";
import { toast } from "react-toastify";

interface SubmitFeedbackParams {
  entity_identification: string;
  user_identification: string;
  authToken: AxiosBasicCredentials;
  data: {
    level: string;
    feedback?: string;
  };
}

export const useSubmitFeedback = () => {
  return useMutation<any, AxiosError<any, any>, SubmitFeedbackParams>(
    ({ entity_identification, user_identification, authToken, data }) =>
      HttpService.post(
        `/entity/${entity_identification}/feedback/${user_identification}`,
        data,
        {
          auth: authToken,
        }
      ),
    {
      onError: (err) => {
        toast.error(err.response?.data?.message || err.message);
      },
    }
  );
};
